// `action` — a base-transaction action button run with the unsaved record
// (its validations and confirmation unchanged); shown only when it stopped.

import AutoStep from './AutoStep'
import type { StepProps } from './common'

export default function ActionStep(props: StepProps) {
  return <AutoStep {...props} retryLabel="Run it again" note="The action did not complete." />
}
